import {Box, Stack, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

export const UserFarmsView: React.FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Stack direction="column">
                <Stack direction="row" height="4rem" alignItems="center" justifyContent="space-between">
                    <Typography fontSize={20} fontWeight={500} textTransform="uppercase">
                        {t("users.farms_view.title")}
                    </Typography>
                </Stack>
                <Stack direction="column" gap="1.25rem">
                    <Box padding="1.5rem" bgcolor="white">
                        Item 1
                    </Box>
                    <Box padding="1.5rem" bgcolor="white">
                        Item 2
                    </Box>
                </Stack>
            </Stack>
        </>
    );
};
